var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesAttachmentTracking = function SvgYeswareSalesAttachmentTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 19.422,
    fill: "#ECF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.064 22.582a14.204 14.204 0 0 0-20.09 0L18.8 43.755a10.463 10.463 0 0 0 14.797 14.797l17.198-17.203a6.719 6.719 0 1 0-9.496-9.493L30.712 42.433a2.041 2.041 0 1 0 2.885 2.89L44.184 34.73a2.64 2.64 0 0 1 3.732 3.734L30.712 55.667a6.382 6.382 0 1 1-9.027-9.027L42.86 25.467a10.125 10.125 0 1 1 14.32 14.32L41.3 55.666a2.04 2.04 0 1 0 2.884 2.885l15.88-15.882a14.202 14.202 0 0 0 0-20.09v.002Z",
    fill: "#29ABE2"
  })));
};
export default SvgYeswareSalesAttachmentTracking;